import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isEmpty, noop, map,
} from 'lodash';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { normalizeAmount } from '../../utils/transformer.util';
import {
  Button,
  Select,
  SearchSelect,
  Input,
  InputDate
} from '../../components/base/index';

const MySwal = withReactContent(Swal);

export default class PengaturanTanggalStruktur extends Component {
  constructor(props) {
    super(props);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._getPrmStaffRombelOptions = this._getPrmStaffRombelOptions.bind(this);
    this.onClickSubmit = this.onClickSubmit.bind(this);
    this.onClickUpdate = this.onClickUpdate.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this.getDate = this.getDate.bind(this);
    this._setForm = this._setForm.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { organizations_id } = school_unit;
    this.state = {
      page: 1,
      filters: {},
      form: {
        value: {
          organizations_id: organizations_id
        },
        error: {},
      },
      param: {},
    };
  }

  componentDidMount() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { school_unit, organizations_id } = user;
    const { date_close, date_open } = school_unit;
    if (date_close && date_open) {
      this._setForm(data);
    }
    // this._onSearchContent();
    this._getSchoolUnitsOptions();
    this._getPrmStaffRombelOptions();
    this.getDate();
  }


  async _getPrmStaffRombelOptions(filters = {}) {
    const { getPrmStaffRombelOptions, user } = this.props;
    const { school_unit, user_group } = user;
    const { levels_id } = school_unit;
    const res = await getPrmStaffRombelOptions(filters);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        staff: res,
      },
    }));
  }

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find(item => item.value == units_id);

    // console.log(units_id)
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : '',
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }
  // componentDidUpdate(prevProps) {
  //   // const { user } = this.props;
  //   // const { workingUnit } = user;
  //   // const { user: prevUser } = prevProps;
  //   // const { workingUnit: prevWorkingUnit } = prevUser;

  //   // if (!isEqual(workingUnit, prevWorkingUnit)) {
  //   //   this.handleGetData();
  //   // }
  //   if (!isEqual(prevProps, this.props)) {
  //     this._onSearchContent({ page: 1 });
  //   }
  // }

   async getDate(payload = {}) {
    const { filters, param, form } = this.state;
    const { getDate, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units = user_group.name == 'pusat' || user_group.name == 'perwakilan' ? (filters.units_id ? filters.units_id : '') : school_unit.id;
    console.log(units);

    const res = await getDate({
      ...payload,
      organizations_id
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState(prevState => ({
      ...prevState,
      getDate: res,
    }));
  }

  async _setForm() {
    const { user, getDate } = this.props;
    const { organizations_id, school_unit } = user;
    const { date_open, date_close } = school_unit;
    const { form } = this.state;
    console.log(date_open)
    // console.log({label: data.code+" - "+data.name, value:data.code})

    try {
      const payload = await getDate({
        organizations_id
      });

      this.setState({
        form: {
          value: {
            organizations_id: organizations_id,
            date_close: payload.date_close,
            date_open: payload.date_open,
          },
          error: {},
        },
      });
    } catch (err) {
      // err action
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    if (name === 'user_groups_id') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          username: '',
        },
      }));
    }
    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      if (name === 'perwakilan_id') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              perwakilan_id: value,
              units_id: '',
            },
          },
        }));
        this._getSchoolUnitsOptions({ perwakilan_id: value.value });
        // if(value.value == 'all'){
        // this._onSearchContent();
        // }
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value)
          ? param.find(i => i.value == value.value).attributes.levels_id
          : '';

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              classrooms_id: '',
              levels_id: levels_units,
              units_id: value,
            },
          },
        }));
      }
      this._onSearchContent();
    });
  }

  async _onSearchContent(params = {}) {
    const { filters, param } = this.state;
    const savedFilters = JSON.parse(window.localStorage.getItem('param')) || '';
    const prm_usergroups = savedFilters.userGroups;


    this.setState(async () => {
      try {
        const { handleListMasterPositions, user } = this.props;
        const { school_unit, organizations_id } = user;
        const result = await handleListMasterPositions({
          organizations_id,
          units_id: school_unit.id,
          filters,
        });

        
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listJabatan: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listJabatan: [],
            },
          },
        }));
      }
      // }
    });
  }

  async onSubmit() {
    const { history, handleSaveDateSettings } = this.props;
    const { form } = this.state;
    const { value } = form;
    await handleSaveDateSettings(value);
    history.push('/dashboard/pengaturan/jabatan');
  }

 

  _onFormChange(event) {
    const { form, param } = this.state;
    const { details } = form.value;
    const { user } = this.props;
    const { school_unit, organizations_id } = user;
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;

    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;
    //   if (name === 'staff'){
    //     console.log(value)
    //     const selectedStaff = param.staff.find(
    //       (item) => item.value == value.value
    //     )
    //     var parts = selectedStaff.label.split(' - ');
    //     const code = selectedStaff.label.split(' - ')[0].trim();
    // const staff_name = parts.length > 1 ? parts[1].trim() : '';
    // form.value.name = staff_name;
    // form.value.code = code;
    //   }
      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        
        newList = prevState.form.value[fieldName] || [];
        newListError = prevState.form.error[fieldName] || [];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
       
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    },
    () => {
      // if (name === 'classes_id') {
      //   this._getParamOptionsAcademics( 'classrooms', {classes_id: value, organizations_id });
      // }
      if (name === 'is_active' && !inputArray) {
        this._setIsBlocked(value);
      }
      if (name === 'levels_id') {
        this._getClassesOptions({ filters: { levels_id: [value] } });
      }
      if (name === 'classes_id') {
        const param = this.state.param.classes_prm;
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              // graduate: param.find(i => i.value == value).attributes.graduate,
            },
          },
        }));
      }
    });
  }

  async onClickSubmit() {
    const { history, handleSaveDateSettings, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    console.log(value)
    const { organizations_id } = user;
    await handleSaveDateSettings(value);
    history.push('/dashboard/pengaturan/tanggal-struktural');
    history.go(0);
  }

  async onClickUpdate() {
    const { history, handleEditMasterPositions, user } = this.props;
    const { form } = this.state;
    const { value } = form;
    const { organizations_id } = user;
    await handleEditMasterPositions(value);
    history.push('/dashboard/pengaturan/jabatan');
    history.go(0);
  }

  async onClickEdit(val) {
    const { history } = this.props;
    history.push('/dashboard/pengaturan/jabatan', {
      data: val,
      isEdit: true,
    });
    history.go(0);
  }

  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
        </div>
      </td>
    );
  }

  onClickAdd() {
    const { history } = this.props;
    history.push('/dashboard/pengaturan/tambah-master-mapel', {
      // isEdit: true,
      // data: { units_id: units_id},
    });
  }

  render() {
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { form, filters, param, getDate } = this.state;
    const { listJabatan } = form.value;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const dataGet = data || '';
    
    const dateSet = getDate?getDate:''
    // console.log(getDate?getDate.date_open:'')

    // Format ke Bahasa Indonesia
      const formatTanggal = (tgl) => {
        const date = new Date(tgl);
        return date.toLocaleDateString('id-ID', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        });
      };

      const kalimat = `Tanggal Buka Pengisian Jabatan Struktural ${formatTanggal(getDate?getDate.date_open:'')}, Tanggal Tutup Pengisian Jabatan Struktural ${formatTanggal(getDate?getDate.date_close:'')}`;
      // form.value.date_open = dateSet.date_open?dateSet.date_open:form.value.date_open
      // form.value.date_close = dateSet.date_close?dateSet.date_close:form.value.date_close
      // console.log(kalimat);
    return (
      
      <div className="manage-registration">
        <h1>Pengaturan Tanggal Struktur</h1>
        <hr />
        <div className="absensi-rekap__custom-form">
         <div
          style={{
            backgroundColor: "#FEF3C7", // kuning muda
            border: "1px solid #FCD34D",
            borderRadius: "12px",
            padding: "16px",
            fontSize: "14px",
            color: "#4B5563",
            marginBottom: "20px",
            marginTop: "20px"
          }}
        >
         {kalimat}
        </div>
          <div className="absensi-rekap__custom-form-row">
             <InputDate
                type="date"
                name="date_open"
                label="Tanggal Buka"
                onChange={this._onFormChange}
                value={form.value.date_open}
                error={form.error.date_open || ''}
              />
            </div>
            <div style={{marginTop:"2%"}}>
               <InputDate
                  type="date"
                  name="date_close"
                  label="Tanggal Tutup"
                  onChange={this._onFormChange}
                  value={form.value.date_close}
                  error={form.error.date_close || ''}
                />
          </div>
        </div>
          <div className="student-list__header">
            <div className="student-list__button">
                <Button
                  type="button"
                  title="Simpan"
                  onClick={this.onClickSubmit}
                />
            </div>
          </div>

      </div>
    );
  }
}
PengaturanTanggalStruktur.propTypes = {
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
PengaturanTanggalStruktur.defaultProps = {
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
